import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Constant } from '../../constant';

@Component({
  selector: 'app-snak-bar-alert',
  templateUrl: './snak-bar-alert.component.html',
  styleUrls: ['./snak-bar-alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SnakBarAlertComponent {

  constructor(
    public snackBarRef: MatSnackBarRef<SnakBarAlertComponent>,
    public constant: Constant,
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      message: string,
      subMessage: string,
      type: 'success' | 'warning' | 'error',
      contactSupport?: boolean,
    }
  ) {
    this.data.message = !!this.data.message ? this.data.message : 'Message';
    this.data.subMessage = !!this.data.subMessage ? this.data.subMessage : '';
    this.data.type = !!this.data.type ? this.data.type : 'success';
    this.data.contactSupport = this.data.contactSupport ?? false;
  }

  public openSupport() {
    const number = this.constant.whatsapp.replace(/\g/s, '');
    window.open(`https://api.whatsapp.com/send?phone=+52${number}&text=Hola`, '_blank');
    this.snackBarRef.dismiss();
  }

}
